import React from "react";
import { Outlet } from "react-router-dom";
import { LoginWrapper } from "./styled";
import usePageTracking  from "../hooks/usePageTracking";

const LoginLayout = () =>{
  if (process.env.REACT_APP_ENVIRONMENT === "production") {
    usePageTracking();
  }

  return (
    <LoginWrapper>
      <Outlet/>
    </LoginWrapper>
  )
}

export default LoginLayout;